import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../contexts/i18n/index';
import OTALogo from '../OTALogo';
import { OfficialPartnerIcon } from '../img';

import type { Configs } from '@shared/types/configs';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './PartnerInfo.module.scss';

import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  configs: Configs;
  logoLink: string;
  partnerName: string;
  showPartnerLogo: boolean;
  isOfficialPartner: boolean;
  hotelName?: string;
  textStyle?: (typeof TEXT_STYLES)[keyof typeof TEXT_STYLES];
};

const PartnerInfo = ({
  configs: { bookDirectlyWithHotelVar },
  hotelName,
  i18n: { translate },
  isOfficialPartner,
  logoLink,
  partnerName,
  showPartnerLogo,
  textStyle,
}: Props) => {
  const bookDirectLabel = (
    <BpkText textStyle={textStyle ?? TEXT_STYLES.label3}>
      {translate('book_direct_with_hotel')}
    </BpkText>
  );
  const bookDirectWithIcon = (
    <div className={cls('PartnerInfo__desc')}>
      <img src={OfficialPartnerIcon} alt="" aria-hidden />
      {bookDirectLabel}
    </div>
  );
  const partnerLogo = <OTALogo src={logoLink} name={partnerName} />;

  let partnerContent;
  if (
    isOfficialPartner &&
    bookDirectlyWithHotelVar === 'official_icon_with_text'
  ) {
    partnerContent = showPartnerLogo ? (
      <div className={cls('PartnerInfo')}>
        {partnerLogo}
        {bookDirectLabel}
      </div>
    ) : (
      bookDirectLabel
    );
  } else if (
    isOfficialPartner &&
    bookDirectlyWithHotelVar === 'official_icon_with_text_and_hotel_name'
  ) {
    partnerContent = showPartnerLogo ? (
      <div className={cls('PartnerInfo')}>
        {partnerLogo}
        {bookDirectWithIcon}
      </div>
    ) : (
      <div className={cls('PartnerInfo')}>
        {hotelName && (
          <BpkText
            textStyle={TEXT_STYLES.label1}
            className={cls('PartnerInfo__hotelName')}
            tagName="p"
          >
            {hotelName}
          </BpkText>
        )}
        {bookDirectWithIcon}
      </div>
    );
  } else {
    partnerContent = showPartnerLogo ? (
      <div className={cls('PartnerInfo')}>{partnerLogo}</div>
    ) : (
      <BpkText textStyle={TEXT_STYLES.label1}>
        {translate('book_on_hotels_website_label')}
      </BpkText>
    );
  }

  return partnerContent;
};

export default withI18n(withConfiguration(PartnerInfo));
